export const ViewServicesButton = ({ service }) => {
  if (!service?.embed_url) return null;
  return (
    <div className="view-services-button-container">
      <a className="plain-button" href={service.embed_url}>
        View Funeral Services
      </a>
    </div>
  );
};
